import { ConfigFetchError } from './load';
import { ConfigValidationError } from './validate';

export function isChunkLoadError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err);
  return /dynamically imported module|importing a module script failed|ChunkLoadError|Loading chunk/i.test(msg);
}

export function renderConfigError(err: unknown, onRetry: () => void): void {
  const root = document.getElementById('root');
  if (!root) return;
  root.innerHTML = '';

  const wrap = document.createElement('div');
  wrap.setAttribute(
    'style',
    'min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0f172a;color:#e2e8f0;font-family:system-ui,sans-serif;padding:24px;'
  );
  const card = document.createElement('div');
  card.setAttribute('style', 'max-width:560px;background:#1e293b;border-radius:12px;padding:32px;');

  const h = document.createElement('h1');
  h.setAttribute('style', 'font-size:20px;margin:0 0 12px;');
  const p = document.createElement('p');
  p.setAttribute('style', 'font-size:14px;line-height:1.5;margin:0 0 16px;color:#94a3b8;');

  let isChunk = false;
  if (err instanceof ConfigValidationError) {
    h.textContent = "This app's configuration is invalid.";
    card.appendChild(h);
    const ul = document.createElement('ul');
    ul.setAttribute('style', 'font-size:13px;color:#cbd5e1;margin:0 0 16px;padding-left:20px;');
    for (const issue of err.issues) {
      const li = document.createElement('li');
      li.textContent = issue;
      ul.appendChild(li);
    }
    card.appendChild(ul);
  } else if (err instanceof ConfigFetchError) {
    h.textContent = "Couldn't load this app's configuration.";
    p.textContent = err.message;
    card.appendChild(h);
    card.appendChild(p);
    if (err.detail) {
      const pre = document.createElement('pre');
      pre.setAttribute(
        'style',
        'font-size:12px;background:#0f172a;padding:12px;border-radius:8px;overflow:auto;color:#f87171;white-space:pre-wrap;'
      );
      pre.textContent = err.detail;
      card.appendChild(pre);
    }
  } else if (isChunkLoadError(err)) {
    isChunk = true;
    h.textContent = 'This app was just updated.';
    p.textContent = 'Reload to get the latest version.';
    card.appendChild(h);
    card.appendChild(p);
  } else {
    h.textContent = 'Something went wrong starting the app.';
    p.textContent = String(err);
    card.appendChild(h);
    card.appendChild(p);
  }

  const btn = document.createElement('button');
  btn.setAttribute(
    'style',
    'background:#7B2C29;color:#fff;border:none;border-radius:8px;padding:10px 20px;font-size:14px;cursor:pointer;'
  );
  btn.textContent = isChunk ? 'Reload' : 'Retry';
  btn.onclick = () => {
    if (isChunk) {
      window.location.reload();
    } else {
      root.innerHTML = '';
      onRetry();
    }
  };
  card.appendChild(btn);

  wrap.appendChild(card);
  root.appendChild(wrap);
}
